import 'intl-tel-input/build/js/utils.js'
import uncoverPassword from '../js/uncover_password.js'
window.uncoverPassword = uncoverPassword
import isEmail from '../js/is_email.js'
import add_invalid_feedback from '../js/add_invalid_feedback.js'
import remove_invalid_feedback from '../js/remove_invalid_feedback.js'
import '../js/countrySelect.js'
import '../js/profile_photo_dropzone.js'
import '../js/identification_document_dropzone.js'
import '../js/academic_transcripts_list-js.js'
import '../js/academic_transcripts_dropzone.js'
import 'flatpickr/dist/flatpickr.min.js'
import '../js/dob_flatpickr.js'
import '../js/expected_intake_year_flatpickr.js'
import formatBytes from '../js/bytes_conversion.js'
import WarningImg from '../img/illustrations/danger-exclamation.svg'
import 'select2/dist/js/select2.min.js'
import '../js/select2.js'

document.addEventListener("DOMContentLoaded",function(){
  // Getting Country data from HTTP header
  var visitor_country = $("#visitor-country").data('visitor-country').toLowerCase() || "my";

  // Student Sign Up form
  //Check if TNC is clicked
  if ($("#tnc_checkbox").length) {
    $("#tnc_checkbox").change(function() {
        if(this.checked) {
            $("#StudentSignUpFormBtn").removeClass("btn-secondary").addClass("btn-primary").prop("disabled", false);
        }
        else{
          $("#StudentSignUpFormBtn").addClass("btn-secondary").removeClass("btn-primary").prop("disabled", true);
        }

    });
  }

  if ($("#student_first_name").length) {
    $("#student_first_name").change(function() {
      remove_invalid_feedback("#student_first_name","#StudentFirstNameInvalidFeedback");
    });
  }

  if ($("#student_last_name").length) {
    $("#student_last_name").change(function() {
      remove_invalid_feedback("#student_last_name","#StudentLastNameInvalidFeedback");
    });
  }

  if ($("#student_email").length) {
    $("#student_email").change(function() {
      remove_invalid_feedback("#student_email","#StudentEmailInvalidFeedback");

      if(!isEmail($("#student_email").val())){
        add_invalid_feedback("#student_email","#StudentEmailInvalidFeedback",null,"Invalid email");
      }
    });
  }

  if ($("#student_phone").length) {
    $("#student_phone").change(function() {
      if(!student_phone_iti.isValidNumber()){
        add_invalid_feedback("#student_phone","#StudentPhoneInvalidFeedback","telephone","Invalid phone number");
      }else{
        remove_invalid_feedback("#student_phone","#StudentPhoneInvalidFeedback");
      }
    });
  }

  if ($("#student_password").length) {
    $("#student_password").change(function() {
      remove_invalid_feedback("#student_password","#StudentPasswordInvalidFeedback");
    });
  }

  if ($("#student_password_confirmation").length) {
    $("#student_password_confirmation").change(function() {
      remove_invalid_feedback("#student_password_confirmation","#StudentPasswordConfirmationInvalidFeedback");
    });
  }



  $('#StudentSignUpFormBtn').click(function(e){
    e.preventDefault();

    var student_first_name_check = true;
    var student_last_name_check = true;
    var student_email_check = true;
    var student_phone_check = true;
    var student_password_check = true;
    var student_password_confirmation_check = true;

    if(jQuery.trim($('#student_first_name').val()) == ""){
      add_invalid_feedback("#student_first_name",'#StudentFirstNameInvalidFeedback');
      student_first_name_check = false;
    }

    if(jQuery.trim($('#student_last_name').val()) == ""){
      add_invalid_feedback("#student_last_name",'#StudentLastNameInvalidFeedback');
      student_last_name_check = false;
    }

    if(jQuery.trim($('#student_email').val()) == ""){
      add_invalid_feedback("#student_email",'#StudentEmailInvalidFeedback');
      student_email_check = false;
    }

    if(jQuery.trim($('#student_phone').val()) == ""){
      add_invalid_feedback("#student_phone",'#StudentPhoneInvalidFeedback',"telephone");
      student_phone_check = false;
    }else{
      if(!student_phone_iti.isValidNumber()){
        add_invalid_feedback("#student_phone","#StudentPhoneInvalidFeedback","telephone","Invalid phone number");
        student_phone_check = false;
      }else{
        remove_invalid_feedback("#student_phone","#StudentPhoneInvalidFeedback");
        $("#student_phone").val(student_phone_iti.getNumber());
        student_phone_check = true;
      }
    }

    if(jQuery.trim($('#student_password').val()) == ""){
      add_invalid_feedback("#student_password","#StudentPasswordInvalidFeedback");
      student_password_check = false;
    }else{
      if($('#student_password').val() != $('#student_password_confirmation').val()){
        add_invalid_feedback("#student_password_confirmation","#StudentPasswordConfirmationInvalidFeedback",null,"password confirmation is not the same as password");
        student_password_confirmation_check = false;
      }
    }

    if(jQuery.trim($('#student_password_confirmation').val()) == ""){
      add_invalid_feedback("#student_password_confirmation","#StudentPasswordConfirmationInvalidFeedback");
      student_password_confirmation_check = false;
    }else{
      if($('#student_password').val() != $('#student_password_confirmation').val()){
        add_invalid_feedback("#student_password_confirmation","#StudentPasswordConfirmationInvalidFeedback",null,"password confirmation is not the same as password");
        student_password_confirmation_check = false;
      }
    }

    if(student_first_name_check && student_last_name_check && student_email_check && student_phone_check && student_password_check && student_password_confirmation_check){
      $('#new_student').submit();
    }
  });

  // Student Complete Profile Button
  // Initializing Phone Number with country
  if ($("#student_phone").length) {
  	var input = document.querySelector("#student_phone");
    var student_phone_iti = intlTelInput(input, {
      initialCountry: visitor_country,
      autoPlaceholder: "off",
      separateDialCode: true,
      customContainer: "w-100",
      preferredCountries: ["my","sg"] ,
      utilsScript: "../intl-tel-input/build/js/utils.js"
    });

    if($("#student_phone").val() != ""){
      student_phone_iti.setNumber($("#student_phone").val());
    }
  }

  if ($("#student_guardian_phone").length) {
    var input = document.querySelector("#student_guardian_phone");
    var student_guardian_phone_iti = intlTelInput(input, {
      initialCountry: visitor_country,
      autoPlaceholder: "off",
      separateDialCode: true,
      customContainer: "w-100",
      preferredCountries: ["my","sg"] ,
      utilsScript: "../intl-tel-input/build/js/utils.js"
    });

    if($("#student_guardian_phone").val() != ""){
      student_guardian_phone_iti.setNumber($("#student_guardian_phone").val());
    }
  }

  //Initialise Country Dropdown for selection
  if ($("#country_select").length) {
    $("#country_select").countrySelect({
      defaultCountry: $("#ServerCountrySelectCode").text() || visitor_country,
      preferredCountries: [],
      responsiveDropdown: true
    });
  }



  if ($("#student_guardian_first_name").length) {
    $("#student_guardian_first_name").change(function() {
      remove_invalid_feedback("#student_guardian_first_name","#StudentGuardianFirstNameInvalidFeedback");
    });
  }

  if ($("#student_guardian_last_name").length) {
    $("#student_guardian_last_name").change(function() {
      remove_invalid_feedback("#student_guardian_last_name","#StudentGuardianLastNameInvalidFeedback");
    });
  }

  if ($("#student_guardian_phone").length) {
    $("#student_guardian_phone").change(function() {
      if(!student_guardian_phone_iti.isValidNumber()){
        add_invalid_feedback("#student_guardian_phone","#StudentGuardianPhoneInvalidFeedback","telephone","Invalid phone number");
      }else{
        remove_invalid_feedback("#student_guardian_phone","#StudentGuardianPhoneInvalidFeedback");
      }
    });
  }

  if ($("#student_addr_first_line").length) {
    $('#student_addr_first_line').change(function(){
      $("#StudentAddrFirstInvalidFeedback").remove();
      $('#student_addr_first_line').removeClass("is-invalid");
    });
  }

  if ($("#student_post_code").length) {
    $('#student_post_code').change(function(){
      $("#StudentPostCodeInvalidFeedback").remove();
      $('#student_post_code').removeClass("is-invalid");
    });
  }

  if ($("#student_state").length) {
    $('#student_state').change(function(){
      $("#StudentStateInvalidFeedback").remove();
      $('#student_state').removeClass("is-invalid");
    });
  }

  $('#StudentUpdateProfileBtn').click(function(e){
    e.preventDefault();

    var student_first_name_check = true;
    var student_last_name_check = true;
    var student_phone_check = true;
    var student_guardian_phone_check = true;

    if(jQuery.trim($('#student_first_name').val()) == ""){
      add_invalid_feedback("#student_first_name",'#StudentFirstNameInvalidFeedback');
      student_first_name_check = false;
    }

    if(jQuery.trim($('#student_last_name').val()) == ""){
      add_invalid_feedback("#student_last_name",'#StudentLastNameInvalidFeedback');
      student_last_name_check = false;
    }

    if(jQuery.trim($('#student_phone').val()) == ""){
      add_invalid_feedback("#student_phone",'#StudentPhoneInvalidFeedback',"telephone");
      student_phone_check = false;
    }else{
      if(!student_phone_iti.isValidNumber()){
        add_invalid_feedback("#student_phone","#StudentPhoneInvalidFeedback","telephone","Invalid phone number");
        student_phone_check = false;
      }else{
        remove_invalid_feedback("#student_phone","#StudentPhoneInvalidFeedback");
        $("#student_phone").val(student_phone_iti.getNumber());
        student_phone_check = true;
      }
    }

    if(jQuery.trim($('#student_guardian_phone').val()) == ""){
      add_invalid_feedback("#student_guardian_phone",'#StudentPhoneInvalidFeedback',"telephone");
      student_guardian_phone_check = false;
    }else{
      if(!student_guardian_phone_iti.isValidNumber()){
        add_invalid_feedback("#student_guardian_phone","#StudentPhoneInvalidFeedback","telephone","Invalid phone number");
        student_guardian_phone_check = false;
      }else{
        remove_invalid_feedback("#student_guardian_phone","#StudentPhoneInvalidFeedback");
        $("#student_guardian_phone").val(student_guardian_phone_iti.getNumber());
        student_guardian_phone_check = true;
      }
    }

    if(student_first_name_check && student_last_name_check && student_phone_check && student_guardian_phone_check){
      $('#update_student_profile').submit();
    }
  });
  // Display File size in human language
  if ($(".byte_size").length) {
    $( ".byte_size" ).each(function( index ) {
      var converted_size = formatBytes($(this).text()); 
      $(this).text(converted_size);
    });
  }

  $(".academic_transcript_list").on('click', "[data-behavior='delete']", function(e) {
    e.preventDefault();
    e.stopPropagation();
    var academic_transcript_list_item = $(this).data("attachmentid");
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      imageUrl: WarningImg,
      imageWidth: 100,
      imageHeight: 100,
      buttonsStyling: false,
      customClass: {
        confirmButton: 'btn btn-danger m-1',
        cancelButton: 'btn btn-secondary m-1'
      },
      showClass: {
        popup: 'animated fadeIn faster'
      },
      hideClass: {
        popup: 'animated fadeOut faster'
      },
      reverseButtons: true,
      showCancelButton: true,
      focusCancel: true,
      confirmButtonText: 'Yes, remove file.'
    }).then((result) => {
      if (result.value) {
        $.ajax({
            type: "POST",
            beforeSend: function(xhr) {xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))},
            url: $(this).attr("href"),
            dataType: "json",
            data: {"_method":"delete"},
            success: function(){
              toastr.success('Academic transcript was successfully deleted.');
              academic_transcript_list.remove('attachment_id', academic_transcript_list_item);
            }
        });
      }
    })
  });
});